export default {
  availabilities: () => '/availabilities',
  home: () => '/',
  login: () => '/login',
  me: () => '/me',
  mySchedule: () => '/schedule',
  missingBankId: () => '/missing-bankid',
  reportedTimes: () => '/reported-times',
  timeReport: () => '/timereport',
  areaOfInterest: () => '/area-of-interest',
};
